// *********** IMPORTS  ***********
import "./MyInfluencer.scss";
import ReactPaginate from "react-paginate";
import { Container, Table } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { LeftArrowIcon } from "../../../Assets/svgIcons";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../../components/loading/loading.component";
import { getAcceptedInfluencer } from "../../../Services/prod/auth.service";
import { CMAuctions } from "../../Public/billing-history/billing-history.styles";

const MyInfluencer = () => {
  // *********** STATES  ***********
  const limit = 10;
  const navigate = useNavigate();
  const { state } = useLocation();
  const auctionId = state?.auctionId;
  const [loading, setLoading] = useState(true);
  const [pageInfluencer, setPageInfluencer] = useState(1);
  const [acceptedInfluencer, setAcceptedInfluencer] = useState({
    outerData:{},
    rows: [],
    count: 0,
  });

  // *********** MY INFLUENCER LIST API FUNCTION CALL  ***********
  useEffect(() => {
    const myInfluencerList = async () => {
      try {
        setLoading(true);
        const acceptedInfluencerRes = await getAcceptedInfluencer(
          pageInfluencer,
          limit,
          auctionId
        );
        if (
          acceptedInfluencerRes?.status === 200 ||
          acceptedInfluencerRes?.status === 201
        ) {
          setLoading(false);
          setAcceptedInfluencer({
            outerData: acceptedInfluencerRes?.data,
            rows: acceptedInfluencerRes?.data?.rows,
            count: acceptedInfluencerRes?.data?.count,
          });
        } else {
          setLoading(false);
          console.log("*** API ERROR ***", acceptedInfluencerRes?.message);
        }
      } catch (error) {
        setLoading(false);
        console.log(error, "ERROR");
      }
    };
    myInfluencerList();
  }, [pageInfluencer]);

  // *********** HANDLE PAGE  ***********
  const handlePageInfluencer = ({ selected }) => {
    setPageInfluencer(selected + 1);
  };
  return (
    <div className="influencer_aknowledge_page">
      <div className="influencer_enrollment_page">
        <Container>
          <div className="page_header">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="back_btn"
            >
              <LeftArrowIcon />
            </button>
            <h2> My Influencer </h2>
            <div className="page_header_right"></div>
          </div>
        </Container>

        {loading ? (
          <Loading />
        ) : (
          <Table responsive className="custom_table">
            <thead>
              <tr>
                <th></th>
                <th>(Converted/Total Traffic)</th>
                <th>Conversion</th>
                {/* <th>Current Commission</th> */}
              </tr>
            </thead>
            <tbody>
              {acceptedInfluencer && acceptedInfluencer?.rows?.length > 0 ? (
                acceptedInfluencer?.rows?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {item?.invited_to_name ? item?.invited_to_name : "N/A"}
                      </td>
                      <td>{`(${item?.converted_traffic}/${item?.total_traffic})`}</td>
                      <td>{item?.conversion ? item?.conversion : 0}</td>
                      {/* <td>
                        {item?.total_earning
                          ? `$${item?.total_earning}`
                          :'$'+ 0}
                      </td> */}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No record found
                  </td>
                </tr>
              )}
              {acceptedInfluencer && acceptedInfluencer?.count > 0 && (
                <tr className="expected_commission_row">
                  <td>Expected Commission</td>
                  <td>
                    {`(${acceptedInfluencer?.outerData?.converted_traffic}/${acceptedInfluencer?.outerData?.total_traffic})`}
                  </td>
                  <td>{acceptedInfluencer?.outerData?.conversion||"0%"}</td>
                  {/* <td>
                    {acceptedInfluencer?.total_earning
                      ? `$${acceptedInfluencer?.total_earning}`
                      : "$" + 0}
                  </td> */}
                </tr>
              )}
            </tbody>
          </Table>
        )}
        {acceptedInfluencer?.count > limit && (
          <CMAuctions>
            <section className="pagination custom_pagination">
              <ReactPaginate
                breakLabel="..."
                nextLabel=""
                previousLabel=""
                forcePage={pageInfluencer - 1}
                onPageChange={handlePageInfluencer}
                pageRangeDisplayed={3}
                pageCount={Math.ceil(acceptedInfluencer?.count / limit)}
                renderOnZeroPageCount={null}
              />
            </section>
          </CMAuctions>
        )}
      </div>
    </div>
  );
};

export default MyInfluencer;
